export const MAX_FILE_SIZE = 50;
export const MAX_NAME_SIZE = 50;
export const MAX_DESCRIPTION_SIZE = 300;

export const roomAttachmentModalActions = {
  addAttachment: 'addAttachment',
  editAttachment: 'editAttachment',
  setUnilateral: 'setUnilateral',
};

export const roomAttachmentTypeIds = {
  unilateral: 2,
  acceptance: 3,
};
